import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { GoogleMap, Marker } from '@capacitor/google-maps';
import { Geolocation } from '@capacitor/geolocation';

import { environment } from 'src/environments/environment';

import { AjaxService } from '../ajax.service';
import { GlobalService } from '../global.service';
import { PlatformMapsService } from '../services/platform-maps.service';

@Component({
    selector: 'app-map',
    templateUrl: './map.page.html',
    styleUrls: ['./map.page.scss'],
    standalone: false
})
export class MapPage implements OnInit, OnDestroy {
    @ViewChild('inpSearchRef', {static: false}) inpSearchRef: ElementRef;
    inpSearch = '';
    filterOrders = 'No';
    filterObjOmschr = '';
    objs: any[] = [];
    objOmschrn: string[] = [];
    markers: Marker[] = [];
    markList: any;
    showMap = false;

    @ViewChild('googlemap') mapRef: ElementRef;
    gmap: GoogleMap;
    latitude: number;
    longitude: number;
    zoom = 8;

    constructor(
        public router: Router,
        public global: GlobalService,
        private ajax: AjaxService,
        private platformMaps: PlatformMapsService,
    ) { }

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }
        this.showMap = true;
        console.log('MapPage init, showMap =', this.showMap);
    }

    ngOnDestroy() {
        this.showMap = false;
        console.log('MapPage destroy, showMap =', this.showMap);
    }

    ionViewDidEnter() {
        Promise.all([
            this.initMap(),
            this.getObjs(),
        ]).then(() => {
            this.updateMarkers();
        });
        this.showMap = true;
        console.log('MapPage ionViewDidEnter, showMap =', this.showMap);
    }

    ionViewDidLeave() {
        this.showMap = false;
        console.log('MapPage ionViewDidLeave, showMap =', this.showMap);
    }

    async getLocation() {
        this.latitude = 51.2777107;
        this.longitude = 5.7496367;
        this.zoom = 8;
        try {
            const position = await Geolocation.getCurrentPosition( { enableHighAccuracy: true } );
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.zoom = 16;
        }
        catch(e) {
            console.log('Geen positie te verkrijgen', e);
        }
    }

    async initMap() {
        await this.getLocation();
        //const h = this.platform.height();
        if (!this.gmap) {
            await GoogleMap.create({
                id: 'my-map', // Unique identifier for this map instance
                element: this.mapRef.nativeElement, // reference to the capacitor-google-map element
                apiKey: this.platformMaps.getMapsApiKey(), // Platform-specific Google Maps API Key
                forceCreate: true,
                config: {
                  center: {
                    // The initial position to be rendered by the map
                    lat: this.latitude,
                    lng: this.longitude,
                  },
                  zoom: this.zoom, // The initial zoom level to be rendered by the map
                },
            }).then((map) => {
                if (map) {
                    console.log('map created', map);
                    this.gmap = map;
                    this.gmap.enableCurrentLocation(true);
                } else {
                    console.log('map not created');
                }
            });
        }
    }

    async getObjs() {
        return this.ajax.get('objListMap', {})
        .then(async(data: any) => {
            console.log('objListMap', data);
            if (data.objs) {
                this.objs = data.objs;
            }
        });
    }

    async updateMarkers() {
        // de filter velden bijwerken
        console.log('updateMarkers', this.objs);
        let r = this.objs.reduce((r,{Omschr}) => (r[Omschr]='', r) , {});
        delete r[''];
        console.log('updateMarkers 1', r);
        this.objOmschrn = Object.keys(r);
        let i = Object.keys(this.objOmschrn).find(key => this.objOmschrn[key] === '');
        delete this.objOmschrn[i];
        console.log('updateMarkers 2', this.objOmschrn);

        // de markers op de kaart bijwerken
        if (this.gmap) {
            await this.gmap.disableClustering();
            await this.addDelMarkers();
            console.log('All markers added/removed');
            await this.gmap.enableClustering();
            console.log('Clustering enabled');
            this.gmap.setOnMarkerClickListener(async (marker) => {
                if (marker.title.includes(':')) {
                    const objID = marker.title.split(':', 1);
                    this.router.navigateByUrl('object/'+objID[0]);
                }
            })
            .then(() => {
                console.log('setOnMarkerClickListener done');
            });
            console.log('updateMarkers done');
        }
    }

    async addDelMarkers() {
        console.log('addDelMarkers');
        Array.prototype.forEach.call(this.objs, async elt => {
            if ((
                    this.inpSearch==''
                    || elt.ID.toLowerCase().includes(this.inpSearch.toLowerCase())
                    || elt.Omschr.toLowerCase().includes(this.inpSearch.toLowerCase())
                    || elt.Adres.toLowerCase().includes(this.inpSearch.toLowerCase())
                    || elt.RefNr.toLowerCase().includes(this.inpSearch.toLowerCase())
                    || elt.KlantRef.toLowerCase().includes(this.inpSearch.toLowerCase())
                ) && (
                    this.filterOrders=='No'
                    || (this.filterOrders=='Open' && elt.openOrders>0)
                ) && (
                    this.filterObjOmschr==''
                    || elt.Omschr.toLowerCase().includes(this.filterObjOmschr.toLowerCase())
                )
            ) {
                if (elt.marker == undefined || elt.marker == '') {
                    await this.gmap.addMarker({
                        coordinate: {
                            lat: parseFloat(elt.Latitude),
                            lng: parseFloat(elt.Longitude),
                        },
                        title: elt.ID + ': ' + elt.Omschr,
                        snippet: elt.ID,
                    }).then((marker) => {
                        console.log('addMarker:', marker);
                        elt.marker = marker;
                    })
                }
            } else {
                // marker verwijderen
                if (elt.marker !== undefined && elt.marker !== '') {
                    await this.gmap.removeMarker(elt.marker).then(() => {
                        console.log('removeMarker:', elt.marker);
                        elt.marker = '';
                    })
                }
            }
        });
        console.log('addDelMarkers done');
        return;
    }

    /*
    async delMarkers() {
        var proms = [];
        if (this.gmap)  {
            console.log('delMarkers');
            this.gmap.disableClustering();
            Array.prototype.forEach.call(this.objs, elt => {
                if (elt.marker !== undefined && elt.marker !== '') {
                    proms.push(
                        this.gmap.removeMarker(elt.marker).then(() => {
                            console.log('removeMarker:', elt.marker);
                            elt.marker = '';
                        })
                    );
                }
            });
        }
        return Promise.all(proms);
    }
    */

    async onChangeSearch(val: string) {
        console.log('onChangeSearch', val, this.inpSearch);
        if (this.gmap && this.objs.length>0) {
            this.updateMarkers();
        }
    }

}
